import {isBidder} from "../../izUtils";

export const BidderLink = (options, bidderSubmitIds, item) => {

    let subjectId = '';
    if (item.saleTypeRelation.valueCode === "02" || item.saleTypeRelation.valueCode === "03") {
        if (item.subjectId) {
            subjectId = '/'+item.subjectId;
        }
    }
    if (isBidder(options)) {
        if ((bidderSubmitIds !== undefined) && (bidderSubmitIds.length)) {
            if (bidderSubmitIds.indexOf(item.id) === -1) {
                return "/bidder/published/single/"+item.id + subjectId;
            } else {
                return "/bidder/singlesigned/"+item.id;
            }
        } else {
            return "/bidder/published/single/"+item.id + subjectId;
        }
    } else {
        return "/single/"+item.id + subjectId;
    }
};
